// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2sAmx","closeBtn":"index-closeBtn-32jUj","videoContainer":"index-videoContainer-qz9Xj"};